module.exports = __webpack_public_path__ + "img/resources-1440.e9a282e6.jpg";